import React from 'react';

// Dashboard
export const DashboardScreen = React.lazy(() => import('./screens/DashboardScreen'));
